import React, { Fragment } from "react";
import { Button } from "@components";
import type { ConfirmModals } from "./types";

const DeletionModal = (props: ConfirmModals) => (
  <Fragment>
    {props.t("DELETION_WARNING")}
    <div className="d-flex justify-content-center pt-5">
      <Button className="w-25 mr-5" onClick={props.onCancel}>
        {props.t("NO")}
      </Button>
      <Button className="w-25" onClick={props.onSubmit}>
        {props.t("YES")}
      </Button>
    </div>
  </Fragment>
);

export default DeletionModal;
